import { Controller } from "@hotwired/stimulus"

// Reloads the enclosing turbo-frame on a timer while the server keeps
// rendering this trigger inside the frame. When the server stops rendering
// it (game day ended, past week), Turbo's morph removes the element,
// Stimulus fires disconnect, and the timer is cleared — the server owns the
// decision to poll.
export default class extends Controller {
  static values = { interval: { type: Number, default: 30000 } }

  connect() {
    this.frame = this.element.closest("turbo-frame")

    // A 5xx (or any response whose body lacks the frame) would otherwise
    // replace the board with Turbo's "Content missing" placeholder;
    // cancelling the event keeps the last rendered board until the next
    // successful tick.
    this.handleFrameMissing = (event) => event.preventDefault()
    this.frame.addEventListener("turbo:frame-missing", this.handleFrameMissing)

    this.inFlight = false
    this.timer = setInterval(() => this.tick(), this.intervalValue)
    this.handleVisibilityChange = () => {
      if (!document.hidden) this.tick()
    }
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
  }

  disconnect() {
    clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
    this.frame.removeEventListener("turbo:frame-missing", this.handleFrameMissing)
  }

  // Single-flight: Turbo cancels a frame's pending request when a new load
  // starts, so a tick that fires while a slow response is still in flight
  // would starve the board instead of refreshing it. reload() returns the
  // frame's `loaded` promise, which settles on success or failure.
  async tick() {
    if (document.hidden || this.inFlight) return

    this.inFlight = true
    try {
      await this.frame.reload()
    } catch {
      // A failed tick keeps the last board; the next tick retries.
    } finally {
      this.inFlight = false
    }
  }
}
